export default "__VITE_ASSET__BHIBjqec__"